<div class="app-documents-list">
  <div class="content">
    @for (document of documents; track $index) {
    <app-documents-list-item [document]="document" />
    }
  </div>
</div>
